import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'LastLetterThin'
})
export class LastLetterThinPipe implements PipeTransform {
	transform(value: string): string {
		let firstPart = '';
		let lastSymbol = '';
		for (let i = 0; i < value.length; i++) {
			if (i !== value.length - 1) {
				firstPart += value[i];
			} else {
				lastSymbol += value[i];
			}
		}

		return `<p>${firstPart} <span>${lastSymbol}</span></p>`;
	}
}
